<template>
  <div class="realTimeMonitoring">
    <div class="stop_content">
      <div class="content_left">
        <div class="shop_list_top">门店列表</div>
        <div class="shop_search">
          <img
            src="../assets/static/search.png"
            alt
            style="width: 24px;height: 24px"
            @click="getShop(1)"
          />
          <input
            type="text"
            v-model="nameTop"
            placeholder="搜索门店、监控"
            class="search_input"
            @change="getShop(1)"
          />
        </div>
        <div class="shop_monitoring">
          <div class="monitoring_list" v-for="item in monitorInfo" :key="item.characteristic">
            <div
              :id="item.characteristic"
              v-if="item.equipmentNo == 2"
              style="height: 160px;width: 277px"
            ></div>
            <div v-else style="height: 160px;width: 277px" class="no_monitor">设备不在线，请检查网络</div>
            <div class="shop_type">{{item.name}}</div>

            <!-- <div style="margin: 14px 9px;">
              <span class="consultation">进店咨询</span>诸神崛起成人用品成人用品（万达店）
            </div>-->
            <div style="margin: 14px 9px;color: #FF901D">
              <span
                class="consultation"
                style="background-color: #FF901D;border: 2px solid #FF901D;"
                v-if="item.status == 1"
              >骑手进店</span>
              <span
                class="consultation"
                style="background-color: #FF901D;border: 2px solid #FF901D;"
                v-if="item.status == 2"
              >顾客进店</span>
              {{item.room_name}}
            </div>
          </div>
          <div class="shop_list">
            <div
              class="monitoring_shop"
              v-for="item in shopList"
              :key="item.id"
              @click="changeMonitoring(item)"
            >
              <!-- <div class="monitoring_anomaly">异常提醒</div> -->
              <!--  style="width:calc(100% - 86px)" -->
              <!-- <div :class="item.id == 3? 'abnormity' : ''">{{item.room_name}}</div> -->
              <div style="line-height: 36px;">
                <span
                  style="background: red;padding: 0 6px;border-radius: 6px;margin-right: 6px"
                  v-if="item.status != ''"
                >{{item.status}}</span>
                <span>{{item.room_name}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content_center" ref="monitorContent">
        <div class="conter_slide" >
          <div v-for="topItem in centerMonitorList" :key="topItem.id">
            <div class="center_top" style="margin-bottom: 6px;">
              <div class="shop_name">
                <div style="margin-bottom: 10px;display: flex;">
                  <div>{{topItem.name}}</div>
                  <div class="shop_img">
                    <img src="../assets/static/doorOpen.png" alt style="width: 20px" />
                    <!-- <img src="../assets/static/doorClose.png" alt style="width: 20px" /> -->
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="doorItem.statusNew"
                      placement="top-start"
                      v-for="(doorItem,index) in topItem.status"
                      :key="index"
                    >
                      <img
                        src="../assets/static/cashierClose.png"
                        alt
                        style="width: 20px"
                        v-if="doorItem.status === 0"
                      />
                      <img
                        src="../assets/static/cashierOpen.png"
                        alt
                        style="width: 21px"
                        v-if="doorItem.status === 1"
                      />
                    </el-tooltip>
                  </div>
                </div>
                <div style="font-size: 14px;color: #E6E9EB;margin-bottom: 6px">
                  <img
                    style="width: 16px;vertical-align: middle;"
                    src="../assets/static/telephone.png"
                    alt
                  />
                  电话：{{topItem.mobile}}
                </div>
                <div style="font-size: 14px;color: #E6E9EB;margin-bottom: 6px">
                  <img
                    style="width: 16px;vertical-align: middle;"
                    src="../assets/static/deliveryAddress.png"
                    alt
                  />
                  地址：{{topItem.address}}
                </div>
              </div>
              <div>
                <div class="operation">
                  <!-- {{topItem.talkbackflage == 1 ? '对讲': '关闭对讲'}} -->
                  <div class="btn_top_small" @click="intercomTop(topItem)">对讲</div>
                  <div class="btn_top_small" @click="openDoor(topItem.id)">开门</div>
                  <div
                    class="btn_top_big"
                    :class="topItem.forceDoor == 1 ? '': 'btn_change'"
                    @click="forceCloseDoor(topItem)"
                  >{{topItem.forceDoor == 1 ? '强制锁门': '清除锁门' }}</div>
                  <div class="btn_top_small" @click="inspectionList(topItem)">稽查</div>
                  <div
                    class="btn_top_small"
                    :class="topItem.alarmFlage == 1 ? '': 'btn_alarm'"
                    @click="alarm(topItem)"
                  >{{topItem.alarmFlage == 1 ? '警报': '警报中'}}</div>
                  <div class="btn_top_small">
                    <div @click="voiceChangePop(topItem,1)">
                      标注
                      <img
                        src="../assets/static/dropDown.png"
                        alt
                        style="width: 24px;vertical-align: middle;"
                      />
                    </div>
                    <div class="voice_pop mark_pop" v-if="topItem.mark != -1">
                      <div style="display: flex;padding:0 12px;flex-wrap: wrap;">
                        <div
                          class="voice_pop_change"
                          :class="item.id === topItem.mark ? 'voice_pop_change_active': ''"
                          v-for="item in topItem.makeDetail"
                          :key="item.id"
                          @click="makeChange(topItem,item)"
                        >{{item.title}}</div>
                      </div>
                      <el-input
                        v-if="topItem.mark==6"
                        type="textarea"
                        :rows="4"
                        placeholder="请输入内容"
                        v-model="topItem.content"
                        style="background: #1c437d !important"
                      ></el-input>
                      <div class="mark_pop_btn">
                        <div class="mark_pop_left" @click="submitMake(topItem,2)">取消</div>
                        <div class="mark_pop_left" @click="submitMake(topItem,1)">确定</div>
                      </div>
                    </div>
                  </div>
                  <div class="btn_top_big" @click="endMonitoring(topItem)">结束监控</div>
                </div>
                <div class="operation">
                  <div class="btn_top_big" @click="guideStore(topItem.id)">门店指南</div>
                  <div class="btn_top_big" @click="takeoutOrder(topItem.id)">外卖订单 
                    <!-- <span style="background-color: red;color:#FFFFFF;padding:0 6px">5</span> -->
                  </div>
                  <div class="btn_top_big" @click="abnormal(topItem.id)">异常提醒</div>
                  <div class="btn_top_small" @click="voiceChangePop(topItem,2)">
                    <div>
                      语音
                      <img
                        src="../assets/static/dropDown.png"
                        alt
                        style="width: 24px;vertical-align: middle;"
                      />
                    </div>

                    <div class="voice_pop" v-if="topItem.voicepop != 1">
                      <div
                        v-for="item in vicoList"
                        :key="item.vico_id"
                        :class="item.vico_id == 1? 'voice_change': ''"
                        @click="changeVico(item,topItem)"
                      >{{item.name}}</div>
                    </div>
                  </div>
                  <div style="display: flex;">
                    <input
                      type="text"
                      class="operation_input"
                      placeholder="自定义输入语音播报"
                      :max="50"
                      v-model="topItem.content"
                    />
                    <div class="operation_btn" @click="customizationVoice(topItem)">ok</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="center_monitor">
              <div
                style="margin-bottom: 12px;z-index:1"
                v-for="(item,index) in topItem.monitor"
                :key="index"
              >
              <!-- 刚才这里把容器的尺寸固定死了，去掉就好了 -->
                <div :id="item.id" v-if="item.live_path != ''"></div>
                <div
                  v-else
                  :style="{width: item.online.width + 'px',height: item.online.height + 'px'}"
                  class="no_monitor"
                >设备不在线，请检查网络</div>
                <div class="monitor_function" v-if="item.live_path != ''">
                  <div>{{item.name}}</div>
                  <div>
                    <!-- <img
                      src="../assets/static/voiceOpen.png"
                      alt
                      style="width: 24px;margin-right: 20px"
                      v-if="item.voice == 1"
                      @click="talkChange(item.player,1,item)"
                    />
                    <img
                      src="../assets/static/voiceClose.png"
                      alt
                      style="width: 24px;;margin-right: 20px"
                      v-if="item.voice == 2"
                      @click="talkChange(item.player,2,item)"
                    />
                    <img
                      src="../assets/static/soundClose.png"
                      alt
                      style="width: 24px;;margin-right: 20px"
                      v-if="item.talk == 2"
                      @click="voiceChange(item.player,2,item)"
                    />
                    <img
                      src="../assets/static/soundOpen.png"
                      alt
                      style="width: 24px;;margin-right: 20px"
                      v-if="item.talk == 1"
                      @click="voiceChange(item.player,1,item)"
                    />
                    <img
                      src="../assets/static/wnlarge.png"
                      alt
                      style="width: 24px;"
                      @click="wnlargeChange(item)"
                    /> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="center_bottom">
          <div style=" display: flex;">
            <div
              v-for="item in divisionGrid"
              :key="item.id"
              class="division_grid"
              :class="item.id == divisionGridIndex ? 'division_grid_change' : ''"
              @click="changeGrid(item.id)"
            >{{ item.number }}宫格</div>
          </div>
          <!-- <el-pagination
            layout="prev, pager, next"
            :total="centerMonitorListTotal"
            class="pagination"
            @current-change="handleCurrentChange"
          ></el-pagination>-->
        </div>
      </div>
      <div class="content_right">
        <div class="content_top">
          <div class="shop_list_top">
            <div>收银台</div>
            <div
              class="shop_pay"
              v-if="CashRegisterOrder.order != undefined"
            >{{CashRegisterOrder.order.pay_name}}</div>
          </div>
          <div class="user_info" v-if="CashRegisterOrder.order != undefined">
            <img src="../assets/static/triangle1.png" alt class="triangle1" />
            <img src="../assets/static/triangle2.png" alt class="triangle2" />
            <img src="../assets/static/triangle3.png" alt class="triangle3" />
            <img src="../assets/static/triangle4.png" alt class="triangle4" />
            <div
              class="user_name"
            >用户：{{CashRegisterOrder.order.nickname}} {{CashRegisterOrder.order.mobile}}</div>
            <div class="user_order">订单号：{{CashRegisterOrder.order.order_on}}</div>
          </div>
          <div class="shop_detail over_flow_style" v-if="CashRegisterOrder.order != undefined">
            <div class="shop_box" v-for="(item,index) in CashRegisterOrder.goods" :key="index">
              <div class="shop_info">
                <img src="../assets/logo.png" alt class="shop_img" />
              </div>
              <div style="flex-grow: 1;margin-left:7px">
                <div class="shop_specification">{{item.name}}</div>
                <div class="shop_shelf">
                  <!-- 货架：
                  <span style="font-size: 17px;margin-right:6px">E21</span>-->
                  <span style="ont-size: 13px;color: #3BC7E5;">已扫描 X{{ item.num }}</span>
                </div>
              </div>
              <div class="shop_price">¥{{item.price}}元</div>
            </div>
          </div>
          <div class="shop_num writing" v-if="CashRegisterOrder.order != undefined">
            共扫描商品
            <span style="font-size: 22px;">{{ CashRegisterOrder.order.num }}</span> 件，共计
            <span style="font-size: 22px;">{{ CashRegisterOrder.order.user_fee }}</span> 元
          </div>
        </div>
        <div class="content_top">
          <div class="shop_list_top">
            <div>操作日志</div>
            <div class="shop_pay" style="color: #FFFFFF;" @click="lookLog()">查看更多</div>
          </div>
          <div class="over_flow_style" style="height: calc(100% - 43px);overflow-y: scroll;">
            <div class="log_list" v-for="logItem in procedureTitle" :key="logItem.id">
              <div class="procedure_time">{{logItem.create_time}}</div>
              <div
                class="procedure_detail"
                :style="itemContent.image_url != '' ? '' : 'height: 50px'"
                v-for="(itemContent,index) in logItem.data"
                :key="itemContent.id"
              >
                <div class="procedure_left">{{itemContent.time}}</div>
                <div
                  class="mains"
                  :class="itemContent.image_url !=''? 'mains_img' : ''"
                  :style="index != (itemContent.leng)?'border-left: 1px dashed #02c3dc':''"
                >
                  <div class="diamond"></div>
                </div>
                <div class="procedure_right" @click="goDetail(itemContent)">
                  <div>{{itemContent.type_name}}</div>
                  <el-image
                    style="height: 100px"
                    :src="itemContent.image_url"
                    :preview-src-list="[itemContent.image_url]"
                    v-if="itemContent.image_url != ''"
                  ></el-image>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="门店指南"
      :visible.sync="dialogGuidanceContent"
      width="60%"
      :before-close="handleClose"
    >
      <el-tabs type="border-card" class="guidanch_img">
        <el-tab-pane>
          <span slot="label">
            门店指南
          </span>
          <div v-html="guidanceContent.content"></div>
        </el-tab-pane>
        <el-tab-pane>
          <span slot="label">
             备注
          </span>
          <div v-html="guidanceContent.notes"></div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <el-dialog title="外卖订单" :visible.sync="dialogVisible" width="66%" :before-close="handleClose">
      <div class="dialog_box">
        <div class="dialog_left">
          <div class="sorting">
            <div class="export_btn" style="margin-right: 20px;">导出</div>
            <div class="export_btn" @click="sortChange(1)">时间正序</div>
            <div
              class="export_btn"
              style="border-left: 0;border-radius: 0 4px 4px 0;"
              @click="sortChange(2)"
            >时间倒序</div>
          </div>
          <div class="table_list" style="flex-grow: 1;">
            <!--  -->
            <el-table :data="tableData" border :row-style="tableRowStyle">
              <el-table-column align="center" prop="id" label="id" width="150"></el-table-column>
              <el-table-column align="center" prop="order_status" label="订单来源" width="160">
                <template slot-scope="scope">{{scope.row.order_status}} {{ scope.row.order_index}}</template>
              </el-table-column>
              <el-table-column align="center" prop="create_time" label="下单时间" width="190"></el-table-column>
              <!-- <el-table-column align="center" prop="nickname" label="用户名"></el-table-column>
              <el-table-column align="center" prop="mobile" label="手机号" width="120"></el-table-column>-->
              <el-table-column align="center" prop="order_sn" label="订单号"></el-table-column>
              <el-table-column align="center" fixed="right" label="操作" width="326">
                <template slot-scope="scope">
                  <el-button
                    @click="handleClick(scope.row)"
                    type="text"
                    class="right_btn"
                    v-if="scope.row.status < 3"
                  >未取货</el-button>
                  <el-button
                    @click="handleClick(scope.row)"
                    type="text"
                    class="right_btn"
                    v-if="scope.row.status > 2"
                  >已取货</el-button>
                  <el-button
                    @click="handleClickVideo(scope.row)"
                    type="text"
                    class="right_btn"
                    v-if="scope.row.status > 2"
                  >视频回放</el-button>
                  <el-button
                    @click="handleLookOrder(scope.row)"
                    type="text"
                    class="right_btn"
                    :class="orderTakeoutId ==scope.row.id ? 'right_btn_color': '' "
                  >查看订单</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div
              style="text-align: center;font-size: 18px;color:#FFFFFF;margin-top: 24px"
            >共{{tableData.length}}条</div>
          </div>
        </div>
        <div class="dialog_right">
          <div class="order_right_top">订单详情</div>
          <div
            class="over_flow_style"
            style="overflow-y: scroll;"
            :style="{height: (tableHeight -43) + 'px'}"
          >
            <div class="shop_detail">
              <div class="shop_box" v-for="(item,index) in orderDetail.goods" :key="index">
                <div class="shop_info">
                  <img :src="item.photos" alt class="shop_img" />
                </div>
                <div style="flex-grow: 1;margin-left:7px;font-size: 14px;">
                  <div style="display: flex;justify-content: space-between;align-items: center;">
                    <div style="flex-grow: 1">
                      <div class="shop_specification">{{item.name}}</div>
                      <div>UPC:{{ item.ucp }}</div>
                    </div>
                    <div style="width: 50px;">x{{ item.num }}</div>
                  </div>
                  <div class="shop_price">
                    <div>货架：{{ item.shelf_number }}</div>
                    <div>￥{{item.price}}元</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="shop_num">
              共计
              <span v-if="orderDetail.goods != undefined">{{ orderDetail.goods.length }}</span>件
            </div>
            <div class="order_price">
              <div class="price_type">
                <div>顾客真实手机号</div>
                <div
                  v-if="orderDetail.order != undefined"
                >{{orderDetail.order.user_phone}}</div>
              </div>
            </div>
            <div class="order_price">
              <div style="font-weight: 600;font-size: 20px;margin-bottom: 20px">订单金额</div>
              <div class="price_type">
                <div>顾客实付</div>
                <div
                  style="color: #FF901Ds;"
                  v-if="orderDetail.order != undefined"
                >{{orderDetail.order.user_fee}}元</div>
              </div>
              <div class="price_type">
                <div>优惠金额</div>
                <div
                  style="color: #FF901Ds;"
                  v-if="orderDetail.order != undefined"
                >{{orderDetail.order.discount_fee}}元</div>
              </div>
              <!-- <div class="price_type">
                <div>商家实收</div>
                <div v-if="orderDetail.order != undefined">{{orderDetail.order.original_price}}元</div>
              </div>-->
              <div class="price_type">
                <div>平台结算</div>
                <div
                  v-if="orderDetail.order != undefined"
                >{{orderDetail.order.order_receivable_amount}}元</div>
              </div>
              <div class="price_type">
                <div>订单原价</div>
                <div
                  v-if="orderDetail.order != undefined"
                >{{orderDetail.order.order_original_amount}}元</div>
              </div>
            </div>
            <div class="order_price" style="border: 0;">
              <div style="font-weight: 600;font-size: 20px;margin-bottom: 20px">订单信息</div>
              <div class="price_type">
                <div>下单时间</div>
                <div v-if="orderDetail.order != undefined">{{orderDetail.order.create_time}}</div>
              </div>
              <div class="price_type">
                <div>平台订单</div>
                <div v-if="orderDetail.order != undefined">{{orderDetail.order.order_on}}</div>
              </div>
              <div class="price_type">
                <div>配送订单号</div>
                <div v-if="orderDetail.order != undefined">{{orderDetail.order.wai_order}}</div>
              </div>
            </div>
            <div class="order_price">
              <div style="font-weight: 600;font-size: 20px;margin-bottom: 20px">骑手信息</div>
              <div class="price_type">
                <div>配送单号</div>
                <div v-if="orderDetail.rider != undefined">{{orderDetail.rider.delivery_sn}}</div>
              </div>
              <div class="price_type">
                <div>骑手姓名</div>
                <div v-if="orderDetail.rider != undefined">{{orderDetail.rider.knight_name}}</div>
              </div>
              <div class="price_type">
                <div>骑手手机号</div>
                <div v-if="orderDetail.rider != undefined">{{orderDetail.rider.knight_phone}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
  
  <script>
import EZUIKit from "ezuikit-js";
// centerMonitor
import {
  roomList,
  monitorInfo,
  centerMonitor,
  powerOutage,
  openDoor,
  abnormalElectricity,
  BuyOutOrder,
  BuyOutDetail,
  Intercom,
  VicoList,
  playVico,
  alarmIndex,
  talkback,
  TagUser,
  logIndex,
  CashierOrder,
  monitorStatus,
  guidance
  // roomIdList
} from "@/utils/api/index";
export default {
  name: "realTimeMonitoring",
  data() {
    return {
      rightRoomId: "",
      rightRoomIdTimer: "",
      room_id: undefined,
      dialogVisible: false,
      shopList: [], // 门店列表
      monitorInfo: [], // 监控列表,
      monitorInfoDestroy: [],
      centerMonitorList: [], // 中间监控数据
      divisionGridIndex: 2, // 几宫格
      guidanceContent: "",
      dialogGuidanceContent: false,
      divisionGrid: [
        {
          id: 1,
          number: 1
        },
        {
          id: 2,
          number: 4
        },
        {
          id: 3,
          number: 9
        },
        {
          id: 4,
          number: 16
        },
        {
          id: 5,
          number: 25
        }
      ],
      orderTakeoutId: "",
      procedureTitle: [],
      tableData: [],
      tableHeight: 300,
      orderDetail: {},
      sortTimeId: "",
      centerMonitorListTotal: 0,
      nameTop: "",
      currentPage: 1,
      vicoList: [],
      CashRegisterOrder: {},
      rightStatusTimer: "",
      roomIdListTimer: ""
    };
  },
  created() {
    // this.getShop();
    this.getMonitirCenter();
  },
  mounted() {
    this.getShop();
    // this.getMonitirCenter();
    // let that = this
    // this.roomIdListTimer = setInterval(() => {
    //   that.getNumStroe()
    // },5000)
    // window.addEventListener("resize", this.changeGrid(this.divisionGridIndex));
  },
  methods: {
    guideStore(id) {
      guidance({
        id
      }).then(res => {
        this.dialogGuidanceContent = true;
        this.guidanceContent = res.data;
        // this.guidanceContent = '<p><img src="http://imagev3.dzxwbj.com/temp/20220414/d89d36693a9c3470560b94973f1df09c.jpg" /></p>↵<p>各类赛事承办<br />定期举办教练内部赛，保持教练的竞技水平；<br />组织学员参加内部和外部邀请赛，通过比赛提升学员心理素质；</p>↵<p>社区比赛也是我们的特色活动，增进邻里关系，共建文明和谐社区。</p>↵<p><img src="http://imagev3.dzxwbj.com/temp/20220415/8a6ccf170c48be939c4364ba868525d7.jpg" /></p>↵<p>【特别提示】</p>↵<p>「乐动乒乓球馆」对所有规则拥有最终解释权，如遇场馆规则的行为影响到他人，我们有权停止您的体验</p>↵<p>请配合!</p>↵<p>&nbsp;</p>↵<p><img src="http://imagev3.dzxwbj.com/temp/20220304/bb3f8d2f292b022f3b8ffc7245874ae7.png" /></p>↵<p>&nbsp;</p>↵<p>&nbsp;</p>↵<p>&nbsp;</p>↵<p><img src="http://imagev3.dzxwbj.com/temp/20220415/ec81f5f2a9f4af71c563f3eba17153df.jpg" /></p>↵<p>【特别提示】</p>↵<p>「乐动乒乓球馆」对所有规则拥有最终解释权，如遇场馆规则的行为影响到他人，我们有权停止您的体验</p>↵<p>请配合!</p>'
      });
    },
    goDetail(info) {
      this.$emit("goOrderDetail", info);
    },
    getLeftStatus() {
      monitorStatus({
        deviceSerial: this.monitorInfo[0].deviceSerial
      }).then(res => {
        this.monitorInfo[0].status = res.data.status;
        console.log(res.data.room_id, res.data.room_id > 0, "res.data.room_id");
        if (res.data.room_id > 0) {
          this.getShop();
          this.destroyMonitor();
          this.getMonitirCenter(res.data.room_id);
        }
      });
    },
    getCashRegisterList() {
      CashierOrder({
        room_id: this.rightRoomId
      }).then(res => {
        this.CashRegisterOrder = res.data;
      });
    },
    getLog() {
      logIndex({
        id: this.rightRoomId
      }).then(res => {
        this.procedureTitle = res.data.map(item => {
          // item.data.leng = item.data.length
          item.data.forEach(itemIndex => {
            itemIndex.leng = item.data.length - 1;
            itemIndex.storeId = this.rightRoomId;
          });
          return item;
        });
      });
    },
    getVicoData(value) {
      VicoList({
        store_id: value.id
      }).then(res => {
        if (res.code == 200) {
          if (res.data.length > 0) {
            value.voicepop = 2;
            this.vicoList = res.data;
          } else {
            this.$message.error("暂无数据");
          }
        }
      });
    },
    changeVico(value, list) {
      playVico({
        vico_id: value.vico_id,
        id: value.id
      }).then(res => {
        if (res.code == 200) {
          list.voicepop = 1;
        }
      });
    },
    customizationVoice(value) {
      Intercom({
        content: value.content,
        store_id: value.id
      }).then(res => {
        if (res.code == 200) {
          this.$message.success(res.data.message);
        }
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.getMonitirCenter(); //待定
    },
    handleClose() {
      this.dialogVisible = false;
      this.dialogGuidanceContent = false;
    },
    sortChange(type) {
      this.takeoutOrder(this.sortTimeId, type);
    },
    endMonitoring(monitoringEnd) {
      monitoringEnd.monitor.forEach(j => {
        if (j.live_path != "") {
          j.player.stop();
        }
      });
      this.centerMonitorList = [];
      // if (this.room_id != undefined) {
      //   this.room_id = undefined;
      //   this.destroyMonitor();
      //   this.getMonitirCenter(monitoringEnd.id); // 待定
      //   this.getShop();
      // }
    },
    getOrderDetail(id) {
      this.orderTakeoutId = id;
      BuyOutDetail({
        id
      }).then(res => {
        this.orderDetail = res.data;
      });
    },
    lookLog() {
      let id;
      if (this.procedureTitle.length > 0) {
        id = this.procedureTitle[0].data[0].storeId;
      } else {
        id = "";
      }
      this.$emit("lookLog", id);
    },
    handleClickVideo(row) {
      this.$emit("clickVideoReplay", {
        type: 1,
        row
      });
    },
    handleLookOrder(row) {
      this.getOrderDetail(row.id);
    },
    forceCloseDoor(item) {
      powerOutage({
        store_id: item.id,
        status: item.forceDoor == 1 ? 0 : 1
      }).then(res => {
        item.forceDoor = item.forceDoor == 1 ? 0 : 1;
        this.$message.success(res.message);
      });
    },
    inspectionList(item) {
      this.$emit("changeMenu", item);
    },
    alarm(item) {
      let status;
      if (item.alarmFlage == 1) {
        item.alarmFlage = 2;
        status = 1;
      } else {
        item.alarmFlage = 1;
        status = 0;
      }
      alarmIndex({ store_id: item.id, status }).then(res => {
        this.$message.success(res.message);
      });
    },
    openDoor(id) {
      openDoor({ store_id: id }).then(res => {
        this.$message.success(res.message);
      });
    },
    intercomTop(value) {
      // if(value.talkbackflage == 1) {
      //   value.talkbackflage = 0
      // } else {
      //   value.talkbackflage = 1
      // }
      talkback({ store_id: value.id, status: 1 }).then(res => {
        // this.$message.success(res.message);
        console.log(res);
      });
    },
    abnormal(id) {
      abnormalElectricity({ store_id: id }).then(res => {
        this.$message.success(res.message);
      });
    },
    voiceChange(item, type, list) {
      if (type == 1) {
        item.closeSound();
        list["talk"] = 2;
      }
      if (type == 2) {
        item.openSound();
        list["talk"] = 1;
      }
    },
    talkChange(item, type, list) {
      if (type == 1) {
        item.stopTalk();
        list["voice"] = 2;
      }
      if (type == 2) {
        item.startTalk();
        list["voice"] = 1;
      }
    },
    wnlargeChange(item) {
      item.player.fullScreen();
    },
    voiceChangePop(item, type) {
      if (type == 1) {
        if (item.mark == -1) {
          item.mark = 8;
        } else {
          item.mark = -1;
        }
      }
      if (type == 2) {
        if (item.voicepop == 1) {
          // item.voicepop = 2;
          this.getVicoData(item);
        } else {
          item.voicepop = 1;
        }
      }
    },
    makeChange(item, type) {
      item.mark = type.id;
    },
    submitMake(detailMake, type) {
      if (type == 2) {
        detailMake.mark = -1;
        return;
      }
      if (type == 1) {
        if (detailMake.mark != 8) {
          TagUser({
            room_id: detailMake.id,
            id: detailMake.mark,
            content: detailMake.content
          }).then(res => {
            detailMake.mark = -1;
            this.$message.success(res.message);
          });
        }
      }
    },
    takeoutOrder(item, sort) {
      this.$nextTick(() => {
        if (sort == undefined) {
          this.sortTimeId = item;
        }
        const div = this.$refs.monitorContent;
        this.tableHeight = div.offsetHeight * 0.8;
        BuyOutOrder({
          room_id: item,
          sort
        }).then(res => {
          this.tableData = res.data;
          if (res.data.length == 0) {
            this.$message.error("暂无外卖订单");
            return;
          }
          if (sort == undefined && res.data.length > 0) {
            this.getOrderDetail(res.data[0].id);
          }
          this.dialogVisible = true;
        });
      });
    },
    getMonitirCenter(id) {
      this.centerMonitorList = [];
      centerMonitor({
        page: this.currentPage,
        limin: 10,
        room_id: id
      }).then(res => {
        if (this.centerMonitorList.length > 0) {
          this.centerMonitorList.forEach(item => {
            item.monitor.forEach(j => {
              if (j.live_path != "") {
                j.player.destroy();
              }
            });
          });
        }
        let centermList = "centermList";
        let index = 0;
        const div = this.$refs.monitorContent;
        const width = div.offsetWidth;
        const height = div.offsetHeight - 143;
        if (res.code == 401) {
          return;
        }
        this.centerMonitorListTotal = res.data.count;
        this.centerMonitorList = res.data.data.map(item => {
          item.makeDetail = [
            { id: 1, title: "疑似偷盗" },
            { id: 2, title: "疑似少付" },
            { id: 3, title: "疑似多付" },
            { id: 4, title: "多人同时" },
            { id: 5, title: "多件商品" },
            { id: 6, title: "其他" }
          ];
          item.voicepop = 1;
          item.mark = -1;
          item.forceDoor = 1;
          item.content = "";
          item.alarmFlage = 1;
          item.talkbackflage = 1;
          item.status = item.status.map(doorDetail => {
            console.log(doorDetail, "doorDetaildoorDetaildoorDetail");
            let tempType = doorDetail.status === 0 ? "：离线" : "：在线";
            doorDetail.statusNew = doorDetail.name + tempType;
            return doorDetail;
          });

          item.monitor.map(j => {
            j.id = centermList + index;
            index++;
            j.voice = 2; // 监控对讲开关
            j.talk = 2; // 监控声音开关
            if (j.live_path == "") {
              j.online = {
                width: width / this.divisionGridIndex - 10,
                height: height / this.divisionGridIndex - 88,
                flagePlayer: 2
              };
            } else {
              // j.online = 1;
              j.player = "";
              j.online = {
                width: width / this.divisionGridIndex - 10,
                height: height / this.divisionGridIndex - 88,
                flagePlayer: 1
              };
            }
          });
          return item;
        });
        this.getMonitirList(id);
      });
    },
    changeGrid(item) {
      this.$nextTick(() => {
        this.divisionGridIndex = item;
        const div = this.$refs.monitorContent;
        const width = div.offsetWidth;
        const height = div.offsetHeight - 143;
        this.centerMonitorList.forEach(item => {
          let widthNew = Number(width / this.divisionGridIndex - 10);
          let heightNew = Number(height / this.divisionGridIndex - 78);
          // if (item.online == 1) {
          //   item.online = {
          //       width: width / this.divisionGridIndex - 10,
          //       height: height / this.divisionGridIndex - 88
          //     };
          //   }
          item.monitor.forEach(j => {
            if (j.live_path == "") {
              j.online = {
                width: width / this.divisionGridIndex - 10,
                height: height / this.divisionGridIndex - 88
              };
            } else {
              j.player.reSize(widthNew, heightNew);
            }
          });
        });
      });
    },
    menuChage(item) {
      this.menuIndex = item.id;
    },
    // getNumStroe() {
    //   roomIdList({}).then(res => {
    //     if(res.data.count != this.shopList.length) {
    //       this.getShop(1)
    //     }
    //   })
    // },
    getShop(type) {
      // this.destroyMonitor(); 后面加
      this.monitorInfo.forEach(item => {
        if(item.live_path != "") {
          item.player.destroy();
        }
      });
      this.monitorInfo = [];
      roomList({
        name: this.nameTop
      }).then(res => {
        if (res.code == 401) {
          return;
        }
        if (res.code != 200) {
          return;
        }
        if (res.data.length == 0) {
          // this.monitorInfo.forEach(item => {
          //   item.player.destroy();
          // });
          this.shopList = res.data;
          this.monitorInfo = [];
          // this.destroyMonitor();
          this.centerMonitorList = [];
        } else {
          this.rightRoomId = res.data[0].id;

          this.getLog();
          this.getCashRegisterList();
          let that = this;
          clearInterval(that.rightRoomIdTimer)
          that.rightRoomIdTimer = setInterval(function() {
            that.getLog();
            that.getCashRegisterList();
          }, 3000);
          this.shopList = res.data;
          this.getMonitoringList(res.data[0].id, res.data[0].room_name, type);
          if (type == 1) {
            this.room_id = res.data[0].id;
            this.nameTop = "";
          }
          if (type == 1) {
            this.destroyMonitor();
            this.getMonitirCenter(res.data[0].id);
          }

          // this.destroyMonitor();
          // this.getMonitirCenter();
        }
      });
    },
    getMonitoringList(id, room_name) {
      let that = this;
      monitorInfo({
        id
      }).then(res => {
        let id = "monitorLeft";
        let index = 1;
        this.monitorInfo = res.data.map(item => {
          if (item.live_path == "") {
            item.equipmentNo = 1;
          } else {
            item.equipmentNo = 2;
          }
          item.characteristic = id + index;
          index++;
          item.room_name = room_name;
          return item;
        });
        // this.monitorInfo.forEach(item => {
        //   item.player.destroy();
        // });
        // this.centerMonitorList.forEach(item => {
        //   item.monitor.forEach(j => {
        //     if (j.live_path != "") {
        //       j.player.destroy();
        //     }
        //   });
        // });

        this.getList();
        this.getLeftStatus();
        clearInterval(that.rightStatusTimer)
        that.rightStatusTimer = setInterval(() => {
          that.getLeftStatus();
        }, 3000);
      });
    },
    getMonitirList() {
      this.$nextTick(() => {
        const div = this.$refs.monitorContent;
        const width = div.offsetWidth;
        const height = div.offsetHeight - 143;
        var themeData = {
          header: {
            color: "#1890ff",
            activeColor: "#FFFFFF",
            backgroundColor: "#000000",
            btnList: []
          },
          footer: {
            color: "#FFFFFF",
            activeColor: "#1890FF",
            backgroundColor: "#00000021",
            btnList: [
              {
                iconId: "capturePicture",
                part: "left",
                defaultActive: 0,
                memo: "截屏按钮",
                isrender: 1
              },
              {
                iconId: "sound",
                part: "left",
                defaultActive: 0,
                memo: "声音按钮",
                isrender: 1
              },

              {
                iconId: "recordvideo",
                part: "left",
                defaultActive: 0,
                memo: "录制按钮",
                isrender: 1
              },
              {
                iconId: "talk",
                part: "left",
                defaultActive: 0,
                memo: "对讲按钮",
                isrender: 1
              },
              {
                iconId: "zoom",
                part: "left",
                defaultActive: 0,
                memo: "电子放大",
                isrender: 1
              },
              {
                iconId: "hd",
                part: "right",
                defaultActive: 0,
                memo: "清晰度切换按钮",
                isrender: 1
              },
              {
                iconId: "expend",
                part: "right",
                defaultActive: 0,
                memo: "全局全屏按钮",
                isrender: 1
              }
            ]
          }
        };
        console.log(width / this.divisionGridIndex - 10,height / this.divisionGridIndex - 68,'测试监控宽高')
        this.centerMonitorList.forEach(item => {
          item.monitor.forEach(j => {
            if (j.live_path != "") {
              // j.player = {};
              j.player = new EZUIKit.EZUIKitPlayer({
                id: j.id, // 视频容器ID
                width: parseInt(width / this.divisionGridIndex - 10),
                height: parseInt(height / this.divisionGridIndex - 68),
                accessToken: j.accessToken,
                url: j.live_path,
                audio: false,
                video: false,
                useHardDev: true,
                // themeData: "simple",
                themeData: themeData,
                plugin: ["talk"],
                handleTalkError:(err) => {
                  console.log(err,'监控报错内容')
                }
              });
            }
          });
        });
      });
    },
    getList() {
      this.$nextTick(() => {
        // var themeData = {
        //   header: {
        //     color: "#1890ff",
        //     activeColor: "#FFFFFF",
        //     backgroundColor: "#000000",
        //     btnList: []
        //   },
        //   footer: {
        //     color: "#FFFFFF",
        //     activeColor: "#1890FF",
        //     backgroundColor: "#00000021",
        //     btnList: [
        //       {
        //         iconId: "deviceName",
        //         part: "left",
        //         defaultActive: 0,
        //         memo: "顶部设备名称",
        //         isrender: 1
        //       }
        //     ]
        //   }
        // };
        this.monitorInfo.forEach(item => {
          if (item.live_path != "") {
            // 这边重复初始化了，变成277*160 这里有两个监控，注释的这个是左侧上方的，另一个是中间页面的监控
            console.log("getList init:");
            item.player = new EZUIKit.EZUIKitPlayer({
              id: item.characteristic, // 视频容器ID
              width: 277,
              height: 160,
              accessToken: item.accessToken,
              url: item.live_path,
              autoPlay: false,
              audio: false
              // themeData: themeData
            });
          }
        });
      });
    },
    changeMonitoring(item) {
      this.room_id = item.id;
      this.monitorInfo.forEach(item => {
        if (item.live_path != "") {
          item.player.destroy();
        }
        // item.player.destroy();
      });
      this.monitorInfo = [];
      this.getMonitoringList(item.id, item.room_name);
      this.rightRoomId = item.id;
      this.getLog();
      this.getCashRegisterList();
      // this.rightRoomIdTimer = setInterval(function() {
      //       this.getLog();
      //       this.getCashRegisterList();
      //     }, 3000);
      this.centerMonitorList.forEach(item => {
        item.monitor.forEach(j => {
          if (j.live_path != "") {
            j.player.destroy();
          }
        });
      });
      this.centerMonitorList = [];
      this.getMonitirCenter(item.id);
    },
    tableRowStyle({ row, rowIndex }) {
      console.log(row);
      if (rowIndex % 2 !== 0) {
        return {
          background: "#16264a"
        };
      } else {
        return {
          background: "#0d193c"
        };
      }
    },
    destroyMonitor() {
      this.centerMonitorList.forEach(item => {
        item.monitor.forEach(j => {
          if (j.live_path != "") {
            j.player.destroy();
          }
        });
      });
      this.centerMonitorList = [];
    },
    destroyOut() {
      this.monitorInfo.forEach(item => {
        if(item.live_path != "") {
          item.player.destroy();
        }
      });
      this.CashRegisterOrder = {};
      this.monitorInfo = [];
      this.procedureTitle = [];
      this.shopList = [];
      clearInterval(this.rightRoomIdTimer);
    }
  },
  beforeDestroy() {
    console.log('ppppppppppppp')
    this.centerMonitorList.forEach(item => {
      item.monitor.forEach(j => {
        if (j.live_path != "") {
          j.player.destroy();
        }
      });
    });
    this.monitorInfo.forEach(item => {
      if(item.live_path != "") {
          item.player.destroy();
        }
    });
    clearInterval(this.rightRoomIdTimer);
    clearInterval(this.rightStatusTimer);
  }
};
</script>
  
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.guidanch_img {
  height: 600px;
  padding: 24px;
  overflow: auto;
  img {
    width: 100%;
  }
  image {
    width: 100%;
  }
}
.realTimeMonitoring {
  height: calc(100vh - 54px);
  // min-width: 1920px;
}
.stop_content {
  width: 100%;
  height: 100%;
  justify-content: space-between;
  display: flex;
  box-sizing: border-box;
  padding: 20px;

  .content_left {
    width: 16%;
    height: 100%;
    background: rgba(33, 52, 86, 0.6);
    .shop_list_top {
      width: 100%;
      height: 43px;
      background-image: url(../assets/static/shopbg.png);
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 100% 100%;
      font-weight: 600;
      font-size: 20px;
      color: #ffffff;
      padding-left: 37px;
      line-height: 43px;
      box-sizing: border-box;
    }
    .shop_search {
      // box-sizing: border-box;
      margin: 20px 20px 11px 11px;
      height: 48px;
      background: #0d264b;
      border-radius: 8px;
      border: 2px solid #5fbcf5;
      display: flex;
      align-items: center;
      padding-left: 24px;
      .search_input {
        width: calc(100% - 54px);
        height: 100%;
        background-color: transparent;
        border: 0;
        font-size: 18px;
        margin-left: 16px;
        color: #d4e6ff;
      }
    }
    .shop_monitoring {
      max-height: calc(100% - 135px);
      width: 100%;
      overflow-y: scroll;
      display: flex;
      flex-direction: column;
      align-items: center;

      .monitoring_list {
        width: 279px;
        font-weight: 500;
        font-size: 16px;
        color: #1ead69;
        background: linear-gradient(178deg, #0e3671 0%, #174486 100%);
        border: 2px solid #5fbcf5;
        margin-bottom: 18px;
        line-height: 28px;
        .shop_type {
          position: relative;
          margin-top: -36px;
          height: 36px;
          line-height: 36px;
          padding-left: 10px;
          background: rgba(41, 69, 110, 0.3);
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
        }
        .consultation {
          font-weight: 400;
          font-size: 16px;
          color: #ffffff;
          background: #1ead69;
          border-radius: 4px;
          border: 2px solid #3be5c6;
          padding: 3px;
          margin-right: 12px;
        }
      }
      .shop_list {
        // margin: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        .monitoring_shop {
          display: flex;
          justify-content: center;
          width: 94%;
          //   height: 96px;
          background: rgba(31, 53, 102, 0.51);
          font-weight: 400;
          font-size: 16px;
          color: #ffffff;
          //   line-height: 96px;
          text-align: center;
          margin-bottom: 8px;
          padding: 14px 8px;
          box-sizing: border-box;
          .monitoring_anomaly {
            background-color: red;
            width: 88px;
            height: 25px;
            border-radius: 6px;
            line-height: 25px;
            color: black;
          }
          .abnormity {
            width: calc(100% - 86px);
          }
        }
      }
    }

    /* 自定义滚动条样式 */
    .shop_monitoring::-webkit-scrollbar {
      width: 3px !important; /* 滚动条宽度 */
    }
  }
  .content_center {
    display: flex;
    flex-direction: column;
    width: 66%;
    height: 100%;
    .conter_slide {
      height: calc(100% - 40px);
      overflow-y: scroll;
      margin-bottom: 12px;
    }
    .conter_slide::-webkit-scrollbar {
      width: 1px !important; /* 滚动条宽度 */
    }

    // background: #213456;
    .center_top {
      // height: 97px;
      background: #16264a;
      padding: 0px 10px 0 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .shop_name {
        font-weight: 400;
        font-size: 18px;
        color: #ffffff;
        .shop_img {
          width: 80px;
          height: 32px;
          display: flex;
          justify-content: space-around;
          align-items: center;
          background: #051238;
        }
      }
      .operation {
        display: flex;
        justify-content: end;
        font-weight: 400;
        font-size: 18px;
        color: #ffffff;
        .btn_alarm {
          font-size: 18px;
          color: #ff2828;
          background: linear-gradient(180deg, #0e3671 0%, #2571b5 100%);
        }
        .btn_top_small {
          width: 80px;
          height: 32px;
          background: #29456e;
          border-radius: 4px;
          line-height: 32px;
          text-align: center;
          margin-right: 10px;
          margin-bottom: 8px;
          cursor: pointer;

          .voice_pop {
            background-image: url(../assets/static/popVoice.png);
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 100% 100%;
            width: 204px;
            position: relative;
            left: -64px;
            top: 8px;
            z-index: 9;
            padding: 20px 0;
            font-size: 14px;
            color: #ffffff;
            .voice_change {
              background: #ff901d;
            }
            .voice_pop_change_active {
              background: #ff901d !important;
              border: 1px solid #ff901d !important;
            }
            .voice_pop_change {
              height: 24px;
              background: #1c437d;
              border-radius: 4px;
              border: 1px solid #e6e9eb;
              // padding: 0px 12px;
              margin-right: 10px;
              line-height: 24px;
              margin-bottom: 12px;
              width: 100px;
            }
          }
          .mark_pop {
            width: 360px;
            left: -156px;
            .mark_pop_btn {
              display: flex;
              justify-content: end;
              margin-top: 20px;
              .mark_pop_left {
                width: 60px;
                height: 28px;
                background: #1c437d;
                border-radius: 4px;
                border: 1px solid #e6e9eb;
                line-height: 28px;
                text-align: center;
                font-weight: 400;
                font-size: 15px;
                color: #ffffff;
                margin-right: 10px;
              }
            }

            .el-textarea {
              width: 92%;
              :deep(.el-textarea__inner) {
                font-size: 13px;
                color: #e6e9eb;
                background: #1c437d !important;
                border: 1px solid #e6e9eb !important;
              }
            }
          }
        }
        .btn_top_big {
          width: 100px;
          height: 32px;
          background: #29456e;
          border-radius: 4px;
          line-height: 32px;
          text-align: center;
          margin-right: 10px;
          margin-bottom: 8px;
          border: 1px solid transparent;
          cursor: pointer;
        }
        .btn_change {
          background: linear-gradient(180deg, #0e3671 0%, #2571b5 100%);
          border: 1px solid #5fbcf5;
          color: #3be5c6;
        }
        .operation_input {
          width: 138px;
          height: 32px;
          background: #051238;
          border-radius: 4px;
          border: 0;
          font-size: 13px;
          color: #a9afbe;
          padding-left: 10px;
        }
        .operation_btn {
          width: 32px;
          height: 32px;
          background: #29456e;
          border-radius: 0px 4px 4px 0px;
          line-height: 32px;
          text-align: center;
          font-weight: 400;
          font-size: 18px;
          color: #ffffff;
          margin-right: 10px;
          cursor: pointer;
        }
      }
    }
    .center_monitor {
      flex-grow: 1;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-bottom: 20px;

      .monitor_function {
        display: flex;
        align-content: center;
        justify-content: space-between;
        align-items: center;
        height: 48px;
        background: #29456e;
        font-size: 18px;
        color: #ffffff;
        padding: 0 20px;
      }
    }
    .center_monitor::-webkit-scrollbar {
      width: 1px !important; /* 滚动条宽度 */
    }

    .center_bottom {
      display: flex;
      justify-content: space-between;
      margin-top: 24px;
      .pagination {
        :deep(.el-pagination__total) {
          font-size: 18px;
          color: rgba(255, 255, 255, 0.88);
          margin-top: 4px;
        }
        :deep(.el-input__inner) {
          background: #051238;
          border-radius: 6px;
          font-size: 16px;
          color: #cccccc;
          border: 0;
          margin-top: 4px;
        }
        :deep(.btn-prev) {
          width: 36px;
          height: 36px;
          background: #29456e;
          border-radius: 7px;
        }
        :deep(.el-pager li) {
          width: 36px;
          height: 36px;
          background: #213456;
          color: #ffffff;
          line-height: 36px;
          font-size: 18px;
          border-radius: 7px;
          border: 1px solid rgba(0, 0, 0, 0.15);
          margin: 0 5px;
        }
        :deep(.btn-next) {
          width: 36px;
          height: 36px;
          background: #29456e;
          border-radius: 7px;
        }
        :deep(.el-pagination__jump) {
          font-size: 18px;
          margin-top: 4px;
        }
        :deep(.el-pager li.active) {
          background: linear-gradient(
            180deg,
            #0e3671 0%,
            #2571b5 100%
          ) !important;
          border: 1px solid #5fbcf5;
        }
      }

      .division_grid {
        width: 80px;
        height: 36px;
        background: #29456e;
        border-radius: 4px;
        line-height: 36px;
        text-align: center;
        font-weight: 400;
        font-size: 18px;
        color: #ffffff;
        margin-right: 28px;
        border: 1px solid transparent;
      }
      .division_grid_change {
        background: linear-gradient(180deg, #0e3671 0%, #2571b5 100%);
        border: 1px solid #5fbcf5;
      }
    }
  }
  .content_right {
    width: 16%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .content_top {
      height: 48%;
      background: #213456;
      display: flex;
      flex-direction: column;
      .shop_list_top {
        width: 100%;
        height: 43px;
        display: flex;
        justify-content: space-between;
        align-content: center;
        background-image: url(../assets/static/shopbg.png);
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 100% 100%;
        font-weight: 600;
        font-size: 20px;
        color: #ffffff;
        padding-left: 37px;
        line-height: 43px;
        box-sizing: border-box;
        .shop_pay {
          font-weight: bold;
          font-size: 16px;
          color: #ff901d;
          margin-right: 11px;
        }
      }
      .shop_detail {
        flex-grow: 1;
        overflow-y: scroll;
        margin: 10px;
        .shop_box {
          display: flex;
          align-items: center;
          padding: 10px;

          .shop_info {
            display: flex;
            .shop_img {
              width: 52px;
            }
          }
          .shop_specification {
            font-size: 16px;
            color: #ffffff;
            margin-bottom: 6px;
          }
          .shop_shelf {
            font-size: 12px;
            color: #e6e9eb;
          }
          .shop_price {
            font-size: 16px;
            color: #ff901d;
          }
        }
      }

      .shop_num {
        width: 90%;
        height: 42px;
        background: linear-gradient(180deg, #0e3671 0%, #2571b5 100%);
        border-radius: 4px;
        line-height: 42px;
        text-align: center;
        font-weight: bold;
        font-size: 16px;
        color: #ffffff;
        margin: 12px auto;
      }
      .user_info {
        position: relative;
        width: 90%;
        height: 53px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: #29456e;
        margin: auto;
        margin-top: 12px;
        line-height: 22px;
        text-align: center;
        padding: 8px 0;
        .user_name {
          font-size: 16px;
          color: #ff901d;
        }
        .user_order {
          font-weight: 400;
          font-size: 14px;
          color: #e6e9eb;
        }

        .triangle1 {
          width: 17px;
          position: absolute;
          left: 0;
          top: 0;
        }
        .triangle2 {
          width: 17px;
          position: absolute;
          top: 0;
          right: 0;
        }
        .triangle3 {
          width: 17px;
          position: absolute;
          bottom: 0px;
          left: 0;
        }
        .triangle4 {
          width: 17px;
          position: absolute;
          bottom: 0px;
          right: 0;
        }
      }
      .log_list {
        // background: #1ead69;
        padding: 12px;
        padding-bottom: 0;
        // overflow-y: scroll;
        font-size: 13px;
        color: #f7feff;
        .procedure_time {
          font-size: 13px;
          color: #f7feff;
          margin-bottom: 14px;
        }
        .procedure_detail {
          display: flex;
          // height: 50px;
          position: relative;
          margin: auto; /* box 居中*/
          /* 使用弹性布局 */
          flex-flow: row nowrap;
          .procedure_left {
            font-size: 12px;
            color: #fff;
            margin-right: 10px;
          }
          .procedure_right {
            font-size: 12px;
            color: #fff;
            line-height: 18px;
            margin-top: -6rpx;
          }
          .mains {
            position: relative;
            width: 14px;
            height: 40px;
            align-self: flex-end;
            .diamond {
              width: 30px;
              height: 30px;
              display: grid;
              place-items: center; /* 居中内容 */
              position: absolute;
              left: -16px;
              top: -16px;
            }
            .diamond::before {
              content: "";
              width: 30%; /* 对角线长度 */
              height: 30%; /* 高的一半 */
              background-color: #2973ef; /* 菱形颜色/ */
              transform: rotateZ(45deg);
            }
          }
          .mains_img {
            height: 150px;
            margin-top: 13px;
          }
        }
      }
    }
  }
}
// 弹窗样式
:deep(.el-dialog) {
  margin-top: 12vh !important;
}
:deep(.el-dialog__header) {
  background: #213456;
  font-weight: bold;
  .el-dialog__title {
    font-size: 20px;
    color: #d4e6ff;
  }
}
:deep(.el-dialog__headerbtn .el-dialog__close) {
  background: linear-gradient(178deg, #0e3671 0%, #174486 100%);
}
.dialog_box {
  display: flex;
  justify-content: space-between;
  .dialog_left {
    width: 74%;
    background: #213456;
    padding: 30px;
    box-sizing: border-box;

    :deep(.el-table__body tr.hover-row > td) {
      background-color: transparent !important;
    }
    .el-table {
      background-color: #0d193c;
      border: 1px solid #2f416b;
    }
    .el-table--border::after,
    .el-table--group::after,
    .el-table::before {
      background: transparent;
    }

    .el-table__fixed-right::before,
    .el-table__fixed::before {
      background: transparent !important;
    }
    .sorting {
      display: flex;
      align-items: center;
      height: 90px;
      background: #29456e;
      padding-left: 30px;
      box-sizing: border-box;
      .export_btn {
        height: 32px;
        background: #29456e;
        border-radius: 4px;
        border: 1px solid #3dc1ff;
        font-weight: 400;
        font-size: 18px;
        color: #ffffff;
        line-height: 32px;
        padding: 0 20px;
      }
    }
    :deep(thead .el-table__cell) {
      background-color: #16264a !important;
      font-weight: 400;
      font-size: 18px;
      color: #ffffff;
    }
    :deep(.el-table__fixed-right-patch) {
      background: #213456 !important;
    }
    .right_btn {
      width: 90px;
      height: 36px;
      background: linear-gradient(180deg, #0e3671 0%, #2571b5 100%);
      border-radius: 4px;
      border: 1px solid #5fbcf5;
      font-weight: 400;
      font-size: 18px;
      color: #ffffff;
      padding-bottom: 28px;
    }
    .right_btn_color {
      background: linear-gradient(180deg, #a9801d 0%, #b56625 100%);
      border-radius: 4px;
      border: 1px solid #fcd486;
    }
    .right_btn_color_big {
      background: linear-gradient(180deg, #0e6871 0%, #25b587 100%);
      border-radius: 4px;
      border: 1px solid #5fbcf5;
    }
  }
  .dialog_right {
    width: 25%;
    background: #213456;
    // overflow-y: scroll;
    padding-top: 30px;
    .order_right_top {
      width: 100%;
      height: 43px;
      background-image: url(../assets/static/shopbg.png);
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 100% 100%;
      font-weight: 600;
      font-size: 20px;
      color: #ffffff;
      padding-left: 37px;
      line-height: 43px;
      box-sizing: border-box;
    }
    /* 自定义滚动条样式 */
    .shop_detail::-webkit-scrollbar {
      width: 3px !important; /* 滚动条宽度 */
    }
    .shop_detail {
      height: 30%;
      overflow-y: scroll;
      margin: 10px;
      font-size: 16px;
      color: #ffffff;

      .shop_box {
        display: flex;
        align-items: center;
        padding: 10px;

        .shop_info {
          display: flex;
          .shop_img {
            width: 52px;
          }
        }
        .shop_specification {
          font-size: 16px;
          margin-bottom: 6px;
          max-width: calc(100% - 50px);
        }
        .shop_price {
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #ff901d;
        }
      }
    }
    .shop_num {
      font-size: 20px;
      color: #ffffff;
      padding-left: 20px;
      margin-top: 2%;
      margin-bottom: 6%;
    }
    .order_price {
      margin: 0px 20px;
      padding-top: 20px;
      padding-bottom: 20px;
      border-top: 1px solid #051238;
      border-bottom: 1px solid #051238;
      color: #ffffff;
      font-size: 16px;
      .price_type {
        display: flex;
        justify-content: space-between;
        align-items: center;
        line-height: 36px;
      }
    }
    .order_info {
      margin: 0px 20px;
      padding-top: 6%;
      padding-bottom: 8%;
      color: #ffffff;
    }
  }
}
:deep(.el-dialog__body) {
  background: #051238;
  padding: 0;
}
.no_monitor {
  background: #0d264b;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  color: #ffffff;
}
</style>
  